import { render, staticRenderFns } from "./BaseInputText.vue?vue&type=template&id=f3fa7d74&"
import script from "./BaseInputText.vue?vue&type=script&lang=js&"
export * from "./BaseInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3fa7d74')) {
      api.createRecord('f3fa7d74', component.options)
    } else {
      api.reload('f3fa7d74', component.options)
    }
    module.hot.accept("./BaseInputText.vue?vue&type=template&id=f3fa7d74&", function () {
      api.rerender('f3fa7d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputText.vue"
export default component.exports